import React from 'react';

import { Switch } from '@lightspeed/flame/Switch';

const EnableAccountSwitch = ({ disabled, checked, onChange }) => (
  <Switch
    disabled={disabled}
    checked={checked}
    onChange={() => {
      onChange();
    }}
  />
);

export default EnableAccountSwitch;
